<template>
  <LLearnContainer>
    <div class="l-learn-audio">
      <lLearnCircle />
      <div class="audio-player">
        <!-- 唱片 -->
        <img class="l-learn-audio-record" :class="{ rotate: currentSong.playing }" src="./images/record.png" alt />
        <img class="l-learn-audio-handle" :class="{ 'handle-play': currentSong.playing }" src="./images/handle.png" alt />
        <div class="l-learn-audio-play">
          <div class="l-learn-audio-bottom">
            <!-- 进度 -->
            <div class="l-progress">
              <!-- 进度条 -->
              <div ref="progressSection" class="l-progress-section">
                <div id="l-progress-audio" class="l-progress-box" draggable="false" onselectstart="return false;"
                  oncontextmenu="return false;" ref="progressBox">
                  <div :style="{ width: `${audio.percent}%` }" ref="LProgress" class="l-progress-small">
                    <span :class="{ cursor: false }" class="circle"></span>
                  </div>
                </div>
              </div>
              <!-- 时间 -->
              <div class="l-time">
                <label class="l-time-show l-current-time">{{ audio.currentTime }}</label>
                <label class="l-time-show">{{ audio.totalTime }}</label>
              </div>
            </div>
            <!-- 播放按钮 -->
            <div class="l-audio-contrl" @click="togglePlayStatus">
              <span :class="{ 'l-pause': currentSong.playing}" class="l-play"></span>
            </div>
            <!-- <span v-if="currentSong.src" class="l-pause-number">剩余暂停次数：{{ currentSong.onceStopNum }}次</span> -->
          </div>
        </div>
      </div>
    </div>
    <PlayerList
      class="player-list"
      :week-list="weekList"
      @play="handlePlay" />
  </LLearnContainer>
</template>

<script>
import laudio from '@/utils/laudio'
import UPModel from '@/models/imgup'
import Study2Model from '@/models/study2'
import LLearnContainer from '@/components/l-learn-container/index.vue'
import lLearnCircle from '@/views/learn-new/components/l-learn-circle'
import PlayerList from './components/PlayerList.vue'

const imgUp = new UPModel()
const study = new Study2Model()


export default {
  name: 'l-xinfa',
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LLearnContainer,
    lLearnCircle,
    PlayerList,
  },
  data() {
    return {
      routeQuery: this.$route.query,
      stage: 101,
      weekList: [],
      currentSong: {},
      laudio: null,
      audio: {
        target: null,
        play: false,
        totalTime: '',
        currentTime: '00:00:00',
        percent: 0,
        src: '',
        status: '',
        duration: 0,
      },
    }
  },
  methods: {
    async getPlayList(id) {
      const res = await study.previewInfo(id)
      const data = [res.data]
      this.weekList = data.map(item => ({
          ...item,
          name: item.recordName,
          extraInfo: `${item.bookName} ${item.lessonName}`,
          audios: item.sourceList.map(audio => ({
              ...audio,
              playing: false,
          })),
          isExpanded: true,
      })) || []
    },
    async getSongUrl(audio) {
      this.$lLoading.show()
      try {
        const res = await imgUp.resource({
          paths: [audio.url],
        })
        this.$lLoading.hide()
        audio.src = res.data[0]
        this.audio.src = res.data[0]
      } catch (err) {
        this.$lLoading.hide()
        console.error(err)
      }
    },
    async handlePlay(audio) {
      if (this.currentSong.src && (this.currentSong.src !== audio.src)) {
          this.currentSong.playing = false
          this.recordPlayData(this.currentSong.id, this.laudio.currentTime)
      }
      this.currentSong = audio
      if (!audio.playing) {
        this.laudio.pause()
      } else {
        if (!audio.src) {
          await this.getSongUrl(audio)
        }
        if (!this.laudio) {
          await this._initAudio(audio.src)
        }
        if (this.laudio.src !== audio.src) {
          this.laudio.src = audio.src
        }
        this.laudio.play()
      }
    },
    async _initAudio(src) {
      this.laudio = laudio({
        autoplay: this.autoplay,
        src,
      })
      this.laudio.addEventListener('loadedmetadata', () => {
        this.audio.totalTime = this._format(this.laudio.duration)
        this.audio.duration = this.laudio.duration
      })
      this.laudio.addEventListener('ended', async () => {
        this.recordPlayData(this.currentSong.id, this.laudio.currentTime)
        this.currentSong.playing = false
        await this.uploadPreview()
        this.getPlayList(this.routeQuery.parentId)
      })
      this.laudio.addEventListener('pause', () => {
      })
      this.laudio.addEventListener('timeupdate', () => {
        this.audio.currentTime = this._format(this.laudio.currentTime)
        this.audio.percent = (this.laudio.currentTime / this.laudio.duration) * 100
      })
    },
    togglePlayStatus() {
      if (this.currentSong.playing) {
        this.laudio.pause()
      } else {
        this.laudio.play()
      }
      this.currentSong.playing = !this.currentSong.playing
    },

    async recordPlayData(id, offset) {
      try {
        await study.recordPlayData({
          bizId: id,
          offset,
          command: 'PAUSE',
        })
      } catch (err) {
        console.log('记录播放数据失败：', err)
      }
    },
    async uploadPreview() {
      await study.uploadPreview({
        id: this.weekList[0].id,
        sourceId: this.currentSong.id
      })
    },
    
    // 格式时间
    _format(timezone) {
      // 取整，防止计算大浮点数
      timezone = parseInt(timezone)
      let time = []
      time[0] = parseInt(timezone / 60 / 60)
      time[1] = parseInt((timezone - time[0] * 60 * 60) / 60)
      time[2] = parseInt((timezone - time[0] * 60 * 60) % 60)

      time = time.map((item) => {
        return this._padStart(item)
      })
      return time.join(':')
    },
    _padStart(number) {
      return number < 10 ? `0${number}` : number
    },
  },
  created() {
    this.getPlayList(this.routeQuery.parentId)
  },
  destroyed() {
    this.laudio ? this.laudio.pause() : null
    if (this.currentSong.src) {
      this.recordPlayData(this.currentSong.id, this.laudio.currentTime)
    }
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'

.audio-player{
  width: 100%;
  height: 100%;
  position: absolute;
  left: -160px;
}

.player-list {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 20;
  right: 0;
}
</style>
